import { useRouteMatch, Link } from "react-router-dom";

import { Card, CardBody, CardText } from "reactstrap";
import Avatar from "../../Avatar";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { chainIds } from "../../../constants";

const ContractsCards = (props) => {
	const { templates, long = false } = props;
	const { url } = useRouteMatch();

	const renderUserImg = (item) => {
		if (item !== null && item?.image) {
			return (
				<img
					height="110"
					width="110"
					alt="user-avatar"
					src={
						item.image.includes("https://")
							? item.image
							: `${process.env.REACT_APP_IPFS_HOST}/${
									item?.customImage ?? item.image
							  }`
					}
					className="img-fluid rounded mt-3 mb-2"
				/>
			);
		} else {
			const stateNum = Math.floor(Math.random() * 6),
				states = [
					"light-success",
					"light-danger",
					"light-warning",
					"light-info",
					"light-primary",
					"light-secondary",
				],
				color = states[stateNum];
			return (
				<Avatar
					initials
					color={color}
					className="rounded mt-3 mb-2"
					content={item?.customName ?? item.name}
					contentStyles={{
						borderRadius: 6,
						fontSize: "calc(48px)",
						width: "100%",
						height: "100%",
					}}
					style={{
						height: "110px",
						width: "110px",
					}}
				/>
			);
		}
	};

	if (templates.length) {
		return templates.map((item) => {
			return long ? (
				<Box key={item._id} sx={{}}>
					<Card className="mb-3">
						<CardBody
							style={{
								padding: "2rem",
							}}
						>
							<div className="d-flex flex-wrap gap-3">
								<div
									className="user-avatar-section"
									style={{
										minHeight: "110px",
										minWidth: "110px",
									}}
								>
									<div className="d-flex align-items-center flex-column">
										{renderUserImg(item)}
									</div>
								</div>
								<div className="info-container" style={{ flexBasis: "70%" }}>
									<div className="border-bottom pb-50 mb-1 d-flex justify-content-between">
										<h4 className="fw-bolder ">Details master contract</h4>
									</div>
									<table className="mt-2 mt-xl-0 w-100">
										<tbody>
											<tr className="table-row">
												<th>Version</th>
												<td>{item.version || "No info"}</td>
											</tr>
											<tr className="table-row">
												<th>Name</th>
												<td>{item.customName ?? item.name}</td>
											</tr>
											<tr className="table-row">
												<th>Type</th>
												<td>{item.type || "No info"}</td>
											</tr>
											<tr className="table-row">
												<th>Symbol</th>
												<td>{item.symbol || "No info"}</td>
											</tr>
											<tr className="table-row">
												<th>Network</th>
												<td>{chainIds[item.chain].name || "No info"}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<Box sx={{ width: "100%" }}>
									<table className="mt-2 mt-xl-0 w-100">
										<tbody>
											<tr className="table-row">
												<th>Owner</th>
												<td>{item.owner || "No info"}</td>
											</tr>
											<tr className="table-row">
												<th>Address</th>
												<td>{item.address || "No info"}</td>
											</tr>
											<tr className="table-row">
												<th>Contract Link</th>
												<td>
													{(
														<a
															href={`${chainIds[item.chain].link}${
																item.address
															}`}
															rel="noreferrer"
															target="_blank"
														>
															link to Etherscan
														</a>
													) || "No info"}
												</td>
											</tr>
											<tr className="table-row">
												<th>IPFS Link</th>
												<td>
													{(
														<a
															href={`${process.env.REACT_APP_IPFS_HOST}/${item.meta}`}
															rel="noreferrer"
															target="_blank"
														>
															link
														</a>
													) || "No info"}
												</td>
											</tr>
											<tr className="table-row">
												<th>Description</th>
												<td>{item.customDescription ?? item.description}</td>
											</tr>
											<tr className="table-row">
												<th>GAS</th>
												<td>{item.gas || "No info"}</td>
											</tr>
										</tbody>
									</table>
								</Box>
								<Tooltip
									disableInteractive
									title={item.isAllowed ? "" : "Need connect to admin"}
								>
									<Box
										sx={{
											width: "100%",
											display: "flex",
											justifyContent: "center",
											columnGap: "2rem",
										}}
									>
										<Button
											color="primary"
											variant="outlined"
											component={Link}
											className="btn-cart move-cart"
											disabled={!item.isAllowed}
											to={`${url}/new/${item._id}`}
										>
											<span>Deploy contract</span>
										</Button>
									</Box>
								</Tooltip>
							</div>
						</CardBody>
					</Card>
				</Box>
			) : (
				<Box sx={{ flexBasis: "45%" }} key={item.id}>
					<Card className="ecommerce-card">
						<Box sx={{ mb: "1rem" }}>
							<CardBody>
								<h6 className="item-name">{item.customName ?? item.name}</h6>
								<CardText className="item-description">
									{item.masterDescription}
								</CardText>
							</CardBody>
							<div className="item-options text-center">
								<Button
									color="primary"
									variant="outlined"
									component={Link}
									className="btn-cart move-cart"
									to={`${url}/master-new/${item.type}`}
								>
									<span>Deploy</span>
								</Button>
							</div>
						</Box>
					</Card>
				</Box>
			);
		});
	}
	return <Box>Have not tamplates</Box>;
};

export default ContractsCards;
